export const STATUS_OPTIONS = [
  { value: "pending", label: "Pending" },
  { value: "approved", label: "Approved" },
  { value: "rejected", label: "Rejected" },
  { value: "cancelled", label: "Cancelled" },
];

export function statusClass(s) {
  return {
    pending: "status-pending",
    approved: "status-approved",
    rejected: "status-rejected",
    cancelled: "status-cancelled",
  }[s] || "status-cancelled";
}

/**
 * Central colour mapping for calendar events (Team calendar bars, Month
 * calendar pills, day-detail dialog rows). Sickness always wins over status:
 * a sickness record is red regardless of pending/approved. Everything else
 * uses the existing status palette so today's Absence UX is unchanged.
 */
export function eventClass(r) {
  if (!r) return "status-cancelled";
  if ((r.request_type || "").toLowerCase() === "sickness") return "status-sickness";
  return statusClass(r.status);
}

/** Human-friendly type label for a request (calendar bars, dialog rows). */
export function eventTypeLabel(r) {
  return (r?.request_type || "").toLowerCase() === "sickness" ? "Sickness" : "Absence";
}

export function fmtDate(s) {
  if (!s) return "—";
  return new Date(s.length > 10 ? s : s + "T00:00:00").toLocaleDateString(undefined, {
    day: "2-digit", month: "short", year: "numeric",
  });
}

export function fmtDateTime(s) {
  if (!s) return "—";
  const d = new Date(s);
  return d.toLocaleString(undefined, { day:"2-digit", month:"short", year:"numeric", hour:"2-digit", minute:"2-digit" });
}

export function daysBetween(start, end) {
  if (!start || !end) return 0;
  const s = new Date(start), e = new Date(end);
  const diff = Math.round((e - s) / 86400000) + 1;
  return diff > 0 ? diff : 0;
}

export function toISODate(d) {
  if (!d) return "";
  if (typeof d === "string") return d;
  const tz = d.getTimezoneOffset() * 60000;
  return new Date(d.getTime() - tz).toISOString().slice(0, 10);
}
